import React, { Fragment } from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "../Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import {
    TableActionIconView, TableActionIconDelete, TableActionIconEdit,
    customHeaderStyle,
    defaultTableHeaderStyles,
    defaultTopLeftCellStyle,
    defaultTopRightCellStyle,
    defaultPaginationOptions
} from "root/Tables/BaseTableComponents";

import {getDocumentUrl} from "root/DataFunctions/CommonDataFns";

const MyResourcesTable = (props) => {

    const onClickItem = (resource_id, mode) =>
    {
        props.clickHandler( mode,  resource_id, props.child_uid );
    }

    const getPreviewSrc = (row) =>
    {
        let previewSrc = '';

        // Check if resource is a link or document
        if(row.link === null || row.link === undefined || row.link === ''){
            previewSrc ='/getFile.php?enc_docid=' + row.document_id;
        }
        else{
            previewSrc = row.link;
        }

        return previewSrc;
    }

    const linkFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        return (
            <Fragment>
                <TableActionIconDelete text="Delete Resource" onClick={() => onClickItem(row.resource_id, 'delete')} />
                <TableActionIconEdit text="Edit Resource" onClick={() => onClickItem(row.resource_id, 'edit')} />
                <TableActionIconView text="View Resource" onClick={() => onClickItem(row.resource_id, 'view')} />
            </Fragment>
        );
    }

    const previewFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        return (
            <Fragment>
                <a href={getPreviewSrc(row)} target="_blank" icon="icon-link">Link</a>
            </Fragment>
        );
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        timestamp: {borderRadius: defaultTopLeftCellStyle, width: "6vw"},
        event_date: {width: "6vw"},
        title: {width: "15vw"},
        post_status_title: {width: "8vw"},
        edit_submit: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "6vw"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "name",
                text: "Name",
                sort: true,
                headerStyle: headerStyle,

            },
            {
                dataField: "description",
                text: "Description",
                headerStyle: headerStyle
            },

            {
                dataField: "rt_name",
                text: "Type",
                textAlign: "center",
                headerStyle: headerStyle,
                style: {overflow:'hidden'},
            },
            {
                dataField: "link",
                text: "Preview",
                formatter: previewFormatter,
                align: 'right',
                headerStyle: headerStyle
            },
            {
                dataField: "options",
                text: "Options",
                formatter: linkFormatter,
                align: 'right',
                headerStyle: headerStyle
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
};

export default MyResourcesTable;

MyResourcesTable.propTypes = {
    post_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};